import React from 'react';
import useEsgScore from '../../hooks/useEsgScore';
import Table from '../Table/Table';
import style from './ESGScore.module.css';

const ESGScore = ({ stock }) => {
  const { esg_score } = useEsgScore(stock.id);

  if (!esg_score || Object.keys(esg_score).length === 0) {
    return (
      <div>
        <h3 className={style.headline}>ESG Score</h3>
        <p className={style.noData}>No data</p>
      </div>
    );
  }

  return (
    <div>
      <h3 className={style.headline}>ESG Score</h3>
      <p className={style.text}>
        A company's environmental, social, and governance risks. Lower score means less risk.
      </p>
      <div>
        <Table>
          <tbody>
            <tr>
              <th>Environment</th>
              <td className={style.points}>
                {esg_score?.environmental_score?.toFixed() || '-'} / 100
              </td>
            </tr>
            <tr>
              <th>Social</th>
              <td className={style.points}>
                {esg_score?.social_score?.toFixed() || '-'} / 100
              </td>
            </tr>
            <tr>
              <th>Governance</th>
              <td className={style.points}>
                {esg_score?.governance_score?.toFixed() || '-'} / 100
              </td>
            </tr>
            <tr>
              <td>Total</td>
              <td className={style.points}>
                {esg_score?.esg_score?.toFixed() || '-'} / 100
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default ESGScore;